<template>
  <div :class="black ? 'mf_title_bl' : 'mf_title'">{{ content }}</div>
</template>
<script>
export default {
  props: ["content", "black"]
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
.mf_title {
  font-weight: bold;
  font-size: 2em;
}
.mf_title_bl {
  font-weight: bold;
  font-size: 2em;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-70) / var(--unnamed-line-spacing-89)
    var(--unnamed-font-family-dosis);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-ffffff);
  text-align: left;
  font: normal normal bold 70px/89px Dosis;
  letter-spacing: 0px;
  color: $mf_ft_color_white;
  opacity: 1;
}
</style>